function errorGAEvent(description) {
  window.gtag?.('event', 'exception', { description })
}

const postFrontendError = (message, actionType) => {
  errorGAEvent(`${actionType} : ${message}`)
}

window.onerror = (message, source, lineno, colno, error) => {
  console.error(error)
  postFrontendError(error ? error.stack : message, 'window.onerror')
}

window.onunhandledrejection = e => {
  console.error(e)
  postFrontendError(
    e.reason.stack || e.reason.toString(),
    'window.onunhandledrejection',
  )
}
